import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import * as css from './TransactionAddressBlock.css';
import {buildNavigationUrl, openUrl} from '../transactionCardUtils';

interface TransactionAddressBlockProps {
    location?: string;
    address?: string;
}

function TransactionAddressBlock({location, address}: TransactionAddressBlockProps) {
    const {t} = useTranslation('eTicket');
    const destination = [location, address].filter(Boolean).join(', ');
    return (
        <css.addressRow data-cy="transaction-address">
            <css.block>
                <css.blockHeading>{t('eventAddress')}</css.blockHeading>
                {location && <css.blockLine>{location}</css.blockLine>}
                {address && <css.blockLine>{address}</css.blockLine>}
            </css.block>
            <Button
                variant="neutral"
                size="chip"
                onClick={() => openUrl(buildNavigationUrl(destination))}
                data-cy="transaction-navigate">
                {t('navigate')}
            </Button>
        </css.addressRow>
    );
}

export default TransactionAddressBlock;
